import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LoadTypeEnum } from '@cai-services';
import { BUP } from '../../core/_models/bup.model';
import { Dimension } from '../../core/_models/dimension.model';
import { MeasurementUnit } from '../../core/_models/measurement-system.model';
import { CaiLoadTypeBaseComponent } from './load-type-base.component';
import { LoadTypeUnit } from './model/load-type-unit.model';

@Component({
  selector: 'cai-load-type',
  templateUrl: './load-type.component.html',
  styleUrls: ['./load-type.component.scss'],
  standalone: false,
})
export class CaiLoadTypeComponent extends CaiLoadTypeBaseComponent {
  @Input() noUpdateOnBlur: boolean;
  @Input() loadTypeSwitchClass: boolean;
  @Output() dimensionsChange = new EventEmitter<Dimension[]>();
  @Output() bupsChange = new EventEmitter<BUP[]>();
  @Output() onUpdateTotals = new EventEmitter();

  constructor(
    protected readonly fb: FormBuilder,
    protected readonly cdr: ChangeDetectorRef,
  ) {
    super(fb, cdr);
  }

  handleChargeableUnitChange(unitState: LoadTypeUnit, event: MeasurementUnit) {
    if (this.loadTypeMode !== LoadTypeEnum.TOTAL) {
      this.chargeableUnitChangeCount += 1;
      this.cdr.detectChanges();
    }
    if (this.loadTypeMode === this.loadTypeEnum.TOTAL) {
      this.convertTotalWeight(unitState, event);
    }
  }
}
